export default {
  filterSearch: 'Filtrez la recherche',
  moreResults: 'Voir plus de résultats',
  noResults: 'Aucun résultat. Lancez une nouvelle recherche.',
  resetSearch: 'Rénitialisez les filtres',
  result: 'résultat',
  results: 'résultats',
  search: 'Rechercher',
  startSearch: 'Débutez votre recherche',
  submitSearch: 'Recherche',
  labels: {
    activity: 'Activités',
    all: 'Tous',
    artwork: 'Œuvres d\'art',
    contentType: 'Types de contenu',
    resource: 'Ressources',
    allSchoolLevels: 'Tous les niveaux',
  },
  keyword: 'Mot-clé',
  keywordPlaceholder: 'Medium, artiste, courant artistique,...',
};



// WEBPACK FOOTER //
// ./src/config/locales/fr/search.js